import ReportFooterCheckboxList from "./ReportFooterCheckboxList";

export default ReportFooterCheckboxList;